import PropTypes from 'prop-types'

import { Icon } from '../display/icon'

const UtlIcon = ({ label = 'Utl', ...rest }) => {
  return (
    <Icon
      label={label}
      {...rest}
      dangerouslySetGlyph={`<svg data-name="Layer 1" viewBox="0 0 300 300"><rect x="87.6" y="15.7" width="21.5" height="266.53" rx="10.8" style="fill:#b7cd65"/><path d="M98.3 287.2a15.7 15.7 0 0 1-15.7-15.7v-245a15.8 15.8 0 1 1 31.5 0v245a15.7 15.7 0 0 1-15.8 15.7zm0-266.5a5.8 5.8 0 0 0-5.7 5.8v245a5.8 5.8 0 0 0 11.5 0v-245a5.8 5.8 0 0 0-5.8-5.8z" style="fill:#1d1d1b"/><rect x="190.9" y="17.8" width="21.5" height="266.53" rx="10.8" style="fill:#b7cd65"/><path d="M201.7 289.3a15.8 15.8 0 0 1-15.8-15.8v-245a15.8 15.8 0 0 1 31.5 0v245a15.7 15.7 0 0 1-15.7 15.8zm0-266.5a5.8 5.8 0 0 0-5.8 5.7v245a5.8 5.8 0 1 0 11.5 0v-245a5.8 5.8 0 0 0-5.7-5.7z" style="fill:#1d1d1b"/><path d="M190.4 47.9h-79.8a5.1 5.1 0 0 1-5-5 5 5 0 0 1 5-5h79.8a5 5 0 0 1 5 5 5 5 0 0 1-5 5zm0 35.8h-79.8a5.1 5.1 0 0 1-5-5 5 5 0 0 1 5-5h79.8a5 5 0 0 1 5 5 5 5 0 0 1-5 5zm0 35.7h-79.8a5 5 0 0 1-5-5 5.1 5.1 0 0 1 5-5h79.8a5 5 0 0 1 5 5 5 5 0 0 1-5 5zm0 35.8h-79.8a5 5 0 0 1-5-5 5.1 5.1 0 0 1 5-5h79.8a5 5 0 0 1 5 5 5 5 0 0 1-5 5zm0 35.8h-79.8a5 5 0 0 1 0-10h79.8a5 5 0 0 1 0 10zm0 35.8h-79.8a5.1 5.1 0 0 1-5-5 5 5 0 0 1 5-5h79.8a5 5 0 0 1 5 5 5 5 0 0 1-5 5zm0 35.8h-79.8a5.1 5.1 0 0 1-5-5 5 5 0 0 1 5-5h79.8a5 5 0 0 1 5 5 5 5 0 0 1-5 5z" style="fill:#1d1d1b"/></svg>`}
    />
  )
}

UtlIcon.propTypes = {
  onClick: PropTypes.func,
  label: PropTypes.string,
  color: PropTypes.string,
  size: PropTypes.oneOf(['tiny', 'small', 'medium', 'large'])
}

export { UtlIcon }
